import { Layout } from 'antd';


const { Content } = Layout;

const PageContentLayout = ({ children, title, icon }) => {
    return (
        <Content className='page-content'>

            {title == null ? (<></>) : (
                <div className='page-content-header'>
                    <h2 className='page-title'>
                        <span className='page-title-icon'>
                            <i className={"svg-icon " + icon}></i>
                        </span>
                        {title}</h2 >
                </div >
            )}

            <div className='page-content-body'>
                {children}
            </div>
        </Content>
    );
};

export default PageContentLayout;
